import { Dictionary } from 'utils/Dictionary'
import Swiper, { Autoplay, Pagination } from 'swiper'

Swiper.use([Autoplay, Pagination])


const LogoSlider = {
  el: {
    root: document.querySelector<HTMLElement>('.logo-slider-block'),
    sliders: document.querySelectorAll<HTMLElement>('.logo-slider-block'),
  },

  translation: {
    slide: Dictionary('genSlide')
  },

  init(): void {
    this.initSwipers()
  },

  initSwipers(): void {

    const BREAKPOINTS = {
      0: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 15,
      },
      775: {
        slidesPerView: 6,
        slidesPerGroup: 6,
        spaceBetween: 30,
      },
      1280: {
        slidesPerView: 8,
        slidesPerGroup: 8,
        spaceBetween: 74,
      },
    }

    Array.prototype.forEach.call(this.el.sliders, item => {
      const swipr = <HTMLElement>item.querySelector('.logo-slider-block__swiper')
      const pagination = <HTMLElement>item.querySelector('.logo-slider-block__pagination')

      // @ts-ignore
      const swiper = new Swiper(swipr, {
        autoplay: {
          delay: 4000,
        },
        breakpoints: BREAKPOINTS,
        grabCursor: true,
        pagination: {
          bulletActiveClass: 'logo-slider-block__pagination-bullet--active',
          bulletClass: 'logo-slider-block__pagination-bullet',
          bulletElement: 'button',
          clickable: true,
          el: pagination,
          renderBullet: (index, className) => `<button class="logo-slider-block__pagination-bullet ${className}" aria-label="${this.translation.slide} ${index}"></button>`,
          type: 'bullets',
        },
        slidesPerView: 3,
        // slidesPerView: "auto",
        spaceBetween: 15,
        slidesPerGroup: 3,
        loop: true,
        loopFillGroupWithBlank: false,
        speed: 900,
      });
    })

  },

}

export default LogoSlider
